export const API_ROUTES = {
    AUTH: {
        status: () => '/auth/status',
        user: () => '/auth/user',
        logout: () => '/auth/logout',
        discord: () => '/api/auth/discord',
    },
    GUILDS: {
        list: () => '/guilds',
        detail: (id) => `/guilds/${id}`,
        music: {
            state: (id) => `/guilds/${id}/music/state`,
            play: (id) => `/guilds/${id}/music/play`,
            pause: (id) => `/guilds/${id}/music/pause`,
            resume: (id) => `/guilds/${id}/music/resume`,
            skip: (id) => `/guilds/${id}/music/skip`,
            stop: (id) => `/guilds/${id}/music/stop`,
            volume: (id) => `/guilds/${id}/music/volume`,
            shuffle: (id) => `/guilds/${id}/music/shuffle`,
            repeat: (id) => `/guilds/${id}/music/repeat`,
            seek: (id) => `/guilds/${id}/music/seek`,
            queue: (id) => `/guilds/${id}/music/queue`,
            queueMove: (id) => `/guilds/${id}/music/queue/move`,
            queueRemove: (id) => `/guilds/${id}/music/queue/remove`,
            queueClear: (id) => `/guilds/${id}/music/queue/clear`,
            import: (id) => `/guilds/${id}/music/import`,
        },
        autoMessages: {
            list: (id) => `/guilds/${id}/automessages`,
            create: (id) => `/guilds/${id}/automessages`,
            update: (id, msgId) => `/guilds/${id}/automessages/${msgId}`,
            toggle: (id, msgId) => `/guilds/${id}/automessages/${msgId}/toggle`,
            delete: (id, msgId) => `/guilds/${id}/automessages/${msgId}`,
        },
        automation: {
            status: (id) => `/guilds/${id}/automation/status`,
        },
    },
    ARTISTS: {
        search: (query) => `/artists/search?q=${encodeURIComponent(query)}`,
        related: (id) => `/artists/${id}/related`,
        suggestions: () => '/artists/suggestions',
    },
    ME: {
        voteStatus: () => '/me/vote-status',
    },
};
